<template>
    <div class="chat"></div>
</template>
<script>
export default {
    name: 'WhatsappFloatComponent',
    props: {
        phone: {
            type: String,
            required: true
        },
        msg: {
            type: String,
            required: true
        }
    }
}
</script>